import {
  DELETE_ESTIMATED_CHARGEABLE_INCOME,
  GET_ESTIMATED_CHARGEABLE_INCOME,
  GET_TAX_COMPUTATION_DETAIL,
  POST_ESTIMATED_CHARGEABLE_INCOME,
  PUT_ESTIMATED_CHARGEABLE_INCOME,
} from "../constants/actionTypes";

const defaultState = {
  estimatedChargeableIncomeArr: [],
  estimatedChargeableIncome : {}
};
let index = "";

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_ESTIMATED_CHARGEABLE_INCOME:
        return {...state,estimatedChargeableIncomeArr:[...action.payload]};
      case GET_TAX_COMPUTATION_DETAIL:
        return {...state,estimatedChargeableIncome:{...action.payload}};
      case POST_ESTIMATED_CHARGEABLE_INCOME:
        return {...state,estimatedChargeableIncomeArr:[...state?.estimatedChargeableIncomeArr,action.payload]};
      case PUT_ESTIMATED_CHARGEABLE_INCOME:
        let data = [...state?.estimatedChargeableIncomeArr];
        index = data?.findIndex(
          (setting) => setting?.id_customer === action.payload?.id_customer,
        );
        if (index != -1) data[index] = { ...action?.payload };
        return {...state,estimatedChargeableIncomeArr: [...data]};
      case DELETE_ESTIMATED_CHARGEABLE_INCOME:
        const updatedArr = [...state].filter(
          (setting) => setting.id !== action.payload,
        );
        return [...updatedArr];
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
